export default __webpack_public_path__ + "static/media/ring_orange.25b28ee1.svg";